var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseCompletePage',{attrs:{"content":_vm.getCoverLandlords,"sdnData":_vm.isLandlords ? _vm.SDN_DATA_LL : _vm.SDN_DATA,"sdnDataAdvised":_vm.isLandlords ? _vm.SDN_DATA_ADVISED_LL : _vm.SDN_DATA_ADVISED,"cardTitle":_vm.$vuetify.breakpoint.lgAndUp
        ? 'Your Landlord’s Insurance quote'
        : 'Your quote'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }